// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"283":"5667751d","455":"12ceacf1","977":"00fabd6e"}[chunkId] + ".chunk.js";
};